import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './NavFooter.scss';

export default class NavFooter extends React.Component {

  render () {
    return (
        <footer>
          <div className="container">
            <div className="row d-flex flex-row justify-content-center pt-4 pb-5">
              <div className="p-1 col-md-3 text-center">
                <p>
                  Need help? Or do you just want to speak to someone?
                </p>
              </div>
              <div className="p-1 col-md-3 text-center">
                <a href="mailto:membership@tscra.org"><FontAwesomeIcon icon="envelope" /> membership@tscra.org</a>
              </div>
              <div className="p-1 col-md-2 text-center">
                <a href="tel:8002427820"><FontAwesomeIcon icon="phone" /> 800-242-7820</a>
              </div>
              <div className="p-1 col-md-4 text-center">
                <a target="_terms" href="https://tscra.org/information/terms-of-use/">Terms of Use</a>&nbsp;&nbsp;&nbsp;
                <a target="_policy" href="https://tscra.org/information/tscra-privacy-policy/">Privacy Policy</a><br/>
                   <span className="copyright-text"> ©️ {new Date().getFullYear()} Texas and Southwestern Cattle Raisers Association; All Rights Reserved.</span>
                   <div className="copyright-text">Version: {global.appVersion}</div>
                </div>
            </div>
          </div>
        </footer>
    );
  }
}
